import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
  FieldArray,
} from 'redux-form';
import {
  Card,
  CardBody,
  Col,
} from 'reactstrap';

import TextBox from '../../../shared/components/form/TextBox';
import renderSelectField from '../../../shared/components/form/Select';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import validate from './validate';
import StudentAssistancesTable from './studentAssistancesTable';
import {
  dateFormat,
} from '../../../helpers/dateFormat';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';

class AssistanceForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  format = (date = '') => {
    if (date) {
      return dateFormat(date.split('T')[0]);
    }

    return '';
  };

  render() {
    const {
      loading,
    } = this.props;

    if (loading) {
      return <LoadingSpinner />;
    }

    const {
      handleSubmit,
      onChangeChecked,
      handleSort,
      handleFilterChangeText,
      handleChangeText,
      submitting,
      onBack,
      logContents,
      canEdit,
      students,
      id,
      date,
      room,
      reference,
      filterValue,
      sortColumn,
      sortType,
    } = this.props;

    return (
      <Card>
        <CardBody>
          <div style={{ marginTop: '10px' }}>
            {canEdit ? (
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
            ) : null
            }
            <button
              type="submit"
              className="btn btn-outline-secondary"
              onClick={onBack}
            >Cancelar - Volver
            </button>
          </div>
          <Form inline className="form" onSubmit={handleSubmit}>
            <Col md={canEdit ? 12 : 2} lx={12}>
              <div className="card__title">
                <h5 className="bold-text">Datos de la asistencia{id ? ` #${id}` : ''}</h5>
              </div>
            </Col>
            <Col md={3} lx={12} style={{ display: 'none' }}>
              <div className="form__form-group">
                <span className="form__form-group-label">Registro Contenido</span>
                <div className="form__form-group-field">
                  <Field
                    name="logContent"
                    placeholder="RegistroContenido"
                    options={logContents}
                    component={renderSelectField}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </Col>
            <Col md={4} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Fecha</span>
                <div className="form__form-group-field">
                  <Field
                    name="date"
                    component={TextBox}
                    onChange={handleChangeText}
                    placeholder="Fecha"
                    autoComplete="false"
                    type={canEdit ? 'date' : 'text'}
                    defaultValue={date}
                    disabled={!canEdit}
                    format={value => (canEdit ? value : this.format(value))}
                  />
                </div>
              </div>
            </Col>
            <Col md={3} lx={12} style={{ display: 'none' }}>
              <div className="form__form-group">
                <span className="form__form-group-label">Aula</span>
                <div className="form__form-group-field">
                  <Field
                    name="room"
                    component={TextBox}
                    placeholder="Aula"
                    autoComplete="false"
                    disabled={!canEdit}
                    maxLength={64}
                    defaultValue={room}
                  />
                </div>
              </div>
            </Col>
            <Col md={4} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label">Referencia</span>
                <div className="form__form-group-field">
                  <Field
                    name="reference"
                    component={TextBox}
                    onChange={handleChangeText}
                    placeholder="Referencia"
                    autoComplete="false"
                    disabled={!canEdit}
                    maxLength={64}
                    defaultValue={reference}
                  />
                </div>
              </div>
            </Col>
          </Form>
          <hr />
          <Form inline className="form">
            <Col md={4} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label">Filtrar alumnos:</span>
                <div className="form__form-group-field">
                  <Field
                    name="filterValue"
                    component={TextBox}
                    placeholder="Texto a buscar"
                    autoComplete="false"
                    type="text"
                    onChange={handleFilterChangeText}
                    maxLength={32}
                    defaultValue={filterValue}
                  />
                </div>
              </div>
            </Col>
          </Form>

          <FieldArray
            key="students"
            name="students"
            component={StudentAssistancesTable}
            items={students}
            editScore={canEdit}
            sortColumn={sortColumn}
            sortType={sortType}
            onChangeChecked={onChangeChecked}
            onSort={handleSort}
          />

          <div style={{ marginTop: '10px' }}>
            {canEdit ? (
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
            ) : null
            }
            <button
              type="submit"
              className="btn btn-outline-secondary"
              onClick={onBack}
            >Cancelar - Volver
            </button>
          </div>
        </CardBody>
      </Card>
    );
  }
}

const ReduxAssistanceForm = reduxForm({
  form: 'AssistanceForm',
  validate,
  enableReinitialize: true,
})(AssistanceForm);

export default setPropsAsInitialValues(ReduxAssistanceForm);

AssistanceForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onChangeChecked: PropTypes.func.isRequired,
  handleSort: PropTypes.func.isRequired,
  handleFilterChangeText: PropTypes.func.isRequired,
  handleChangeText: PropTypes.func.isRequired,

  submitting: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  students: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  logContents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  logContent: PropTypes.shape({}),
  id: PropTypes.number,
  date: PropTypes.string,
  room: PropTypes.string,
  reference: PropTypes.string,

  canEdit: PropTypes.bool,
  filterValue: PropTypes.string,
  sortColumn: PropTypes.string.isRequired,
  sortType: PropTypes.string.isRequired,
};

AssistanceForm.defaultProps = {
  submitting: false,
  canEdit: true,
  filterValue: '',
  id: 0,
  logContent: null,
  reference: null,
  date: '',
  room: '',
};
